<template>
  <div class="bottom-wrap">
    <div class="content">
      <div class="index">
        <span  v-for="(item, index) in nav" :key="item.name" @click="navClick(item.path)">
          {{item.name}}
        </span>
      </div>
      <div class="law">
        <span>版权所有： 中鹏（浙江）机械有限公司</span>
        <span class="ml50">电话: 13905764593 （张先生） </span>
        <span class="ml50" @click="openLink" style="cursor: pointer">备案号： 浙ICP备2024115176号-1 </span>
      </div>
    </div>
    <div class="img">
      <img src="../../../assets/images/contact/ewm.png" alt="">
      <p>扫一扫，联系我们</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Bottom",
    data(){
      return{
        nav:[
          {
            name:'首页',
            path:'/home'
          },
          {
            name:'关于我们',
            path:'/about'
          },
          {
            name:'产品中心',
            path:'/product'
          },
          {
            name:'案例中心',
            path:'/project'
          },
          {
            name:'联系我们',
            path:'/contact'
          },
        ]
      }
    },
    methods:{
      navClick(path){
        this.$router.push(path)
      },
      openLink () {
        window.open('https://beian.miit.gov.cn')
      }
    }
  }
</script>

<style lang="less" scoped>
.bottom-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  background-color: #444444;
  .bottom{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content{
    width: 60%;
    margin-right: 100px;
    .index{
      width: 60%;
      display: flex;
      justify-content: space-between;
      font-size: 20px;
      padding-bottom: 30px;
      color: #cccccc;
    }
    .index :hover{
      font-weight: bold;
      color: #FFFFFF;
      cursor:pointer;
    }
    .law{
      border-top: 1px dashed #666666;
      padding-top: 30px;
      color: #999999;
      font-size: 16px;
      .ml50 {
        margin-left: 50px;
      }
    }
  }
  .img {
    p{
      margin: 0;
      color: #888888;
      font-size: 14px;
    }
    img{
      margin-top: 10px;
      width: 95px;
      height: 91px;
      border: 5px solid #3a8ee6;
    }
  }
}
</style>
